import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSubtasksDisableRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-subtasks-disable',
	path: '/secure/admin/subtasks/DisableSubTasks!default.jspa',
};
